import React from 'react';
import '../App.css';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import { BsBoxArrowUpRight } from 'react-icons/bs';


    


const JobListing = (props) => {
    const [showDescription, setShowDescription] = React.useState(false);

    const handleClick = () => {
        setShowDescription(!showDescription);
      };

    return(<div>

        <div className="job-listing-wrapper" 
        
        onClick={handleClick}
        >
            {/* Has three children divs: */}

            {/* logo */}
            <div className="job-listing-logo-wrapper">
                <img src={props.logo} className="job-listing-logo"/>
            </div>

            {/* Position, Company */}
            <div className="job-listing-title">
              <div>
              <h3 className='job-listing-position'> {props.position} </h3> 
              <h4 className='job-listing-company'>  {props.company} </h4>
              
              </div>
              {showDescription && <div> <p className='job-listing-description'> {props.description} </p> <a href={props.link} target="_blank" style={{fontWeight:'bolder'}}> 
                    Apply here! <BsBoxArrowUpRight> </BsBoxArrowUpRight>
                </a> </div>}
            </div>

            {/* apply here, drop-down for more info */}
            <div className="job-listing-apply">
            <div style={{padding:'0.5rem'}}>
                {!showDescription && <a href={props.link} target="_blank" style={{fontWeight:'bolder'}}> 
                    Apply here! <BsBoxArrowUpRight> </BsBoxArrowUpRight>
                </a>}
            </div>
            
            <div>
                
            {!showDescription && <FaAngleDown size="3rem"/>}
            {showDescription && <FaAngleUp size="3rem"/>}
               
            </div>
            </div>
        
        

        </div>
        <div style={{backgroundColor:'whitesmoke', height:'1rem'}}></div>
        
    </div>)
}

export default JobListing;